import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { useAppDispatch, useAppSelector } from '../redux/hooks';
import { logoutUser } from '../redux/AuthReducer/authSlice';
import { useIdleTimeout } from '../hooks/useIdleTimeout';

/** Auto-logout after this much inactivity (20 minutes). */
const SESSION_TIMEOUT_MS = 20 * 60 * 1000;

/**
 * Mounted once near the app root. Watches for user inactivity while
 * authenticated and automatically logs the user out after `SESSION_TIMEOUT_MS`,
 * redirecting to /login.
 */
const SessionTimeoutManager: React.FC = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { isAuthenticated } = useAppSelector((state) => state.login);

    const handleIdle = useCallback(async () => {
        if (!isAuthenticated) return;
        await dispatch(logoutUser()).unwrap();
        toast.info('You have been logged out due to inactivity.');
        navigate('/login');
    }, [dispatch, navigate, isAuthenticated]);

    useIdleTimeout({
        timeoutMs: SESSION_TIMEOUT_MS,
        onIdle: handleIdle,
        enabled: isAuthenticated,
    });

    return null;
};

export default SessionTimeoutManager;